export const PLACEHOLDER_ACTIVITY_DATE_ISO = '2099-01-01T00:00:00.000Z';
export const PLACEHOLDER_ACTIVITY_START_TIME = 98;
export const PLACEHOLDER_ACTIVITY_END_TIME = 99;
export const ALL_DAY_ACTIVITY_TIME = 100;

